<template>
    <div class="formRightWrap display_center_ud">
        <div class="formBlock">
            <div v-if="callbackurl != ''" class="bianjiaobtn" @click="$router.push({ name: 'sweep', query: { callback: callbackurl, istcm: loginistcm == false ? 0 : 1 } })">扫码登录</div>
            <div v-else class="bianjiaobtn" @click="$router.push({ name: 'sweep' })">扫码登录</div>
            <img
                v-if="callbackurl != ''"
                src="../../assets/img/login/bianjiao.png"
                alt=""
                class="bianjiao"
                @click="$router.push({ name: 'sweep', query: { callback: callbackurl, istcm: loginistcm == false ? 0 : 1 } })"
            />
            <img v-else src="../../assets/img/login/bianjiao.png" alt="" class="bianjiao" @click="$router.push({ name: 'sweep' })" />
            <div class="login_title">
                <a href="javascript:;" :class="{ login_title_active: index == 0 }" @click="tag(0)">验证码登录</a>
                <a href="javascript:;" :class="{ login_title_active: index == 1 }" @click="tag(1)">密码登录</a>
            </div>
            <div class="formWrap">
                <div v-if="index == 0">
                    <div class="inputBar">
                        <!-- <input type="text" v-model="formData.phone" class="width100" placeholder="请输入手机号码" /> -->
                        <el-input placeholder="请输入手机号码" v-model="formData.phone" class="input-with-select">
                            <el-select v-model="selectvalue" slot="prepend" placeholder="请选择" @change="custInfoChange">
                                <el-option v-for="(item, index) in select" :key="index" :label="item.value + '   +' + item.key" :value="item.key"></el-option>
                            </el-select>
                        </el-input>
                    </div>
                    <div class="inputBar">
                        <input type="text" v-model="formData.code" class="width100" placeholder="请输入验证码" />
                        <div style="margin-left: 5px">
                            <a href="javascript:void(0);" v-if="!isdisabled" class="btnNormal" @click="getmsg"> 点击获取 </a>
                            <a href="javascript:void(0);" v-if="isdisabled" class="btnNormal">
                                {{ codeText }}
                            </a>
                        </div>
                    </div>
                </div>
                <div v-if="index == 1">
                    <div class="inputBar">
                        <input type="text" v-model="formData.phone" class="width100" placeholder="请输入手机号码" />
                    </div>
                    <div class="inputBar">
                        <input type="password" v-model="formData.password" class="width100" placeholder="请输入密码" />
                    </div>
                </div>
                <div class="marginBottom20" @click="userLogin" v-on:keyup.enter="userLogin">
                    <a href="javascript:;" class="btnSubmit">{{ logintext }}</a>
                </div>
                <div class="display_between">
                    <a v-if="callbackurl != ''" href="javascript:;" @click="$router.push({ name: 'getpass', query: { callback: callbackurl } })">忘记密码？</a>
                    <a v-else href="javascript:;" @click="$router.push({ name: 'getpass' })">忘记密码？</a>
                    <a v-if="callbackurl != ''" href="javascript:;" @click="$router.push({ name: 'loginRegister', query: { callback: callbackurl } })">注册 >></a>
                    <a v-else href="javascript:;" @click="$router.push({ name: 'loginRegister' })">注册 >></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import ssologin from '../../assets/unit/sso';
export default {
    name: 'login',
    data() {
        return {
            selectvalue: '+86',
            select: [
                { key: '86', value: '中国' },
                { key: '853', value: '中国澳门' },
                { key: '886', value: '中国台湾' },
                { key: '852', value: '中国香港' },
            ],
            index: 0,
            codeText: '',
            // 设置按钮是否禁用
            isdisabled: false,
            formData: {
                phone: '',
                code: '',
                password: '',
            },
            callbackurl: '',
            logintext: '登录',
            userType: 0,
            loginistcm: false,
        };
    },
    created() {
        /** 获取callback地址 */
        if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'callback')) {
            this.callbackurl = decodeURIComponent(this.$route.query.callback);
        }
        if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'istcm')) {
            if (this.$route.query.istcm == 1) this.loginistcm = true;
        }
        var _self = this;
        document.onkeydown = function () {
            var key = window.event.keyCode;
            if (key == 13) {
                _self.userLogin();
            }
        };
    },
    methods: {
        custInfoChange(val) {
            this.selectvalue = '+' + val;
        },
        tag(index) {
            this.index = index;
        },
        getmsg() {
            let time = 60;
            let i = 0;
            let that = this;
            //1.在60秒之内，button上倒计时60秒，并显示
            //2.向controller请求验证码，并发送到指定的手机号上面
            let set = setInterval(function () {
                that.codeText = --time + '秒后重发';
                i++;
                //此变量用于标识只调用一次获取验证码的函数
                if (i == 1) {
                    //使获取验证码按钮不可点击
                    that.isdisabled = true;
                    that.getVerificationCode();
                }
            }, 1000);

            //60秒之后需要做的事情
            setTimeout(function () {
                //恢复获取验证码按钮可点击
                that.isdisabled = false;
                that.codeText = '获取验证码';
                clearInterval(set); //清除计时器
            }, time * 1000); //60000
        },
        getVerificationCode: function () {
            var messagetype = 6;
            var mobile = this.formData.phone;
            var reg = /^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/;
            switch (this.selectvalue) {
                case '+886':
                    messagetype = 10;
                    mobile = 886 + mobile;
                    reg = /^(886)?09\d{8}$/;
                    break;
                case '+852':
                    messagetype = 9;
                    mobile = 852 + mobile;
                    reg = /^([5|6|9])\d{7}$/;
                    break;
                case '+853':
                    mobile = 853 + mobile;
                    messagetype = 9;
                    reg = /^6\d{7}$/;
                    break;
            }

            if (!reg.test(this.formData.phone)) {
                this.$message({
                    message: '手机号格式错误',
                    type: 'warning',
                });
                return;
            }
            this.httphelper
                .post('/api/VerifCodeApi/NoteVerifCode', {
                    type: messagetype,
                    phoneNumber: mobile,
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: '发送成功',
                            type: 'success',
                        });
                    } else if (res.data.code == 233) {
                        this.$message({
                            message: '发送失败',
                            type: 'warning',
                        });
                    }
                });
        },
        userLogin: function () {
            let dom = document.querySelector('.modalWrap');
            if (dom != null) return dom.remove();
            if (this.index == 1) {
                if (this.formData.phone == '' || this.formData.password == '') {
                    this.$msgmodal({
                        title: '系统提示',
                        content: '账号或密码不能为空!',
                        type: 'warn',
                    });
                    return;
                }
                this.logintext = '登录中...';
                this.httphelper
                    .post('/api/LoginApi/GetUserLogin', {
                        phoneNumber: this.formData.phone,
                        pwd: this.formData.password,
                        loginistcm: this.loginistcm,
                    })
                    .then(async res => {
                        if (res.data.code == 232) {
                            this.logintext = '登录';
                            this.$msgmodal({
                                title: '系统提示',
                                content: '账号不存在!',
                                type: 'warn',
                            });
                        } else if (res.data.code == 205) {
                            this.logintext = '登录';
                            this.$msgmodal({
                                title: '系统提示',
                                content: '密码错误!',
                                type: 'warn',
                            });
                        } else if (res.data.code == 260) {
                            this.logintext = '登录';
                            this.$msgmodal({
                                title: '系统提示',
                                content: '账号未激活!',
                                type: 'warn',
                            });
                        } else if (res.data.code == 270) {
                            this.logintext = '登录';
                            this.$msgmodal({
                                title: '系统提示',
                                content: '此账号非中医用户,请切换账号或者联系机构管理员!',
                                type: 'warn',
                            });
                        } else if (res.data.code == 200) {
                            let callbackurl = decodeURIComponent(this.$route.query.callback);
                            localStorage.setItem('nickname', res.data.data.nickname);
                            var aData = new Date();
                            var CurrentDategetTime = 0;
                            var VipEdDategetTime = 0;
                            if (res.data.data.memberDate.m_EndDate) {
                                var CurrentDate =
                                    aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate() + ' ' + aData.getHours() + ':' + aData.getMinutes() + ':' + aData.getSeconds();
                                var VipEdDate = res.data.data.memberDate.m_EndDate;
                                CurrentDategetTime = new Date(CurrentDate.replace(/-/g, '/')).getTime() / 1000;
                                VipEdDategetTime = new Date(VipEdDate.replace(/-/g, '/')).getTime() / 1000;
                            }
                            if (res.data.data.memberDate.m_EndDate == null || parseInt(CurrentDategetTime) - parseInt(VipEdDategetTime) >= 0) {
                                this.userType = 0;
                            } else {
                                if (res.data.data.memberDate.m_Type == 1) {
                                    this.userType = 1;
                                } else if (res.data.data.memberDate.m_Type == 2) {
                                    this.userType = 2;
                                } else {
                                    this.userType = 0;
                                }
                            }
                            localStorage.setItem('userType', this.userType);
                            localStorage.setItem('ResData', JSON.stringify(res.data.data));
                            if (this.$cookies.get('token_chinagp')) {
                                await this.outClearToken(res.data.data.token);
                            } else {
                                this.$cookies.set('token_chinagp', res.data.data.token);
                            }
                            if (this.$route.query.type == 2 && callbackurl.indexOf('gp519.com') == -1) {
                                //   if (this.$route.query.type == 2 && callbackurl.indexOf('localhost') == -1) {
                                if (callbackurl.indexOf('?') > -1) {
                                    callbackurl = callbackurl + '&token=' + res.data.data.token;
                                } else {
                                    callbackurl = callbackurl + '?token=' + res.data.data.token;
                                }
                                window.location.href = callbackurl;
                            } else if (this.$route.query.type == 3) {
                                //   if (this.$route.query.type == 2 && callbackurl.indexOf('localhost') == -1) {
                                if (callbackurl.indexOf('?') > -1) {
                                    callbackurl = callbackurl + '&token=' + res.data.data.token;
                                } else {
                                    callbackurl = callbackurl + '?token=' + res.data.data.token;
                                }
                                window.location.href = callbackurl;
                            } else {
                                let redirectUrl = '/home';
                                setTimeout(() => {
                                    if (this.callbackurl != '') {
                                        // redirectUrl = this.callbackurl + '?token=' + res.data.data.token;
                                        if (callbackurl.indexOf('?') > -1) {
                                            redirectUrl = callbackurl + '&token=' + res.data.data.token;
                                        } else {
                                            redirectUrl = callbackurl + '?token=' + res.data.data.token;
                                        }
                                        window.location.href = redirectUrl;
                                    } else {
                                        const { href } = this.$router.resolve({
                                            path: redirectUrl,
                                        });
                                        window.location.href = href;
                                    }
                                }, 100);
                            }
                        }
                    });
            } else if (this.index == 0) {
                if (this.formData.phone == '' || this.formData.code == '') {
                    this.$msgmodal({
                        title: '系统提示',
                        content: '手机号或验证码不能为空!',
                        type: 'warn',
                    });
                    return;
                }
                var mobile = this.formData.phone;
                switch (this.selectvalue) {
                    case '+86':
                        mobile = 86 + '+' + mobile;

                        break;
                    case '+886':
                        mobile = 886 + '+' + mobile;
                        break;
                    case '+852':
                        mobile = 852 + '+' + mobile;
                        break;
                    case '+853':
                        mobile = 853 + '+' + mobile;
                        break;
                }
                this.logintext = '登录中...';
                this.httphelper
                    .post('/api/LoginApi/GetUsernoteLogin', {
                        phoneNumber: mobile,
                        vcode: this.formData.code,
                        loginistcm: this.loginistcm,
                    })
                    .then(async res => {
                        if (res.data.code == 234) {
                            this.logintext = '登录';
                            this.$msgmodal({
                                title: '系统提示',
                                content: '验证码已失效!',
                                type: 'warn',
                            });
                        } else if (res.data.code == 205) {
                            this.logintext = '登录';
                            this.$msgmodal({
                                title: '系统提示',
                                content: '验证码错误!',
                                type: 'warn',
                            });
                        } else if (res.data.code == 270) {
                            this.logintext = '登录';
                            this.$msgmodal({
                                title: '系统提示',
                                content: '此账号非中医用户,请切换账号或者联系机构管理员!',
                                type: 'warn',
                            });
                        } else if (res.data.code == 200) {
                            let callbackurl = decodeURIComponent(this.$route.query.callback);
                            localStorage.setItem('nickname', res.data.data.nickname);
                            var aData = new Date();
                            var CurrentDategetTime = 0;
                            var VipEdDategetTime = 0;
                            console.log(res.data.data, '====duanxin');
                            if (res.data.data.memberDate.m_EndDate) {
                                var CurrentDate =
                                    aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate() + ' ' + aData.getHours() + ':' + aData.getMinutes() + ':' + aData.getSeconds();
                                var VipEdDate = res.data.data.memberDate.m_EndDate;
                                CurrentDategetTime = new Date(CurrentDate.replace(/-/g, '/')).getTime() / 1000;
                                VipEdDategetTime = new Date(VipEdDate.replace(/-/g, '/')).getTime() / 1000;
                            }
                            if (res.data.data.memberDate.m_EndDate == null || parseInt(CurrentDategetTime) - parseInt(VipEdDategetTime) >= 0) {
                                this.userType = 0;
                            } else {
                                if (res.data.data.memberDate.m_Type == 1) {
                                    this.userType = 1;
                                } else if (res.data.data.memberDate.m_Type == 2) {
                                    this.userType = 2;
                                } else {
                                    this.userType = 0;
                                }
                            }
                            localStorage.setItem('userType', this.userType);
                            localStorage.setItem('ResData', JSON.stringify(res.data.data));
                            if (this.$cookies.get('token_chinagp')) {
                                await this.outClearToken(res.data.data.token);
                            } else {
                                this.$cookies.set('token_chinagp', res.data.data.token);
                            }
                            if (this.$route.query.type == 2 && callbackurl.indexOf('gp519.com') == -1) {
                                if (callbackurl.indexOf('?') > -1) {
                                    callbackurl = callbackurl + '&tel=' + this.formData.phone;
                                } else {
                                    callbackurl = callbackurl + '?tel=' + this.formData.phone;
                                }
                                window.location.href = callbackurl;
                            } else if (this.$route.query.type == 3) {
                                //   if (this.$route.query.type == 2 && callbackurl.indexOf('localhost') == -1) {
                                if (callbackurl.indexOf('?') > -1) {
                                    callbackurl = callbackurl + '&token=' + res.data.data.token;
                                } else {
                                    callbackurl = callbackurl + '?token=' + res.data.data.token;
                                }
                                window.location.href = callbackurl;
                            } else {
                                let redirectUrl = '/home';
                                setTimeout(() => {
                                    if (this.callbackurl != '') {
                                        // redirectUrl = this.callbackurl + '?token=' + res.data.data.token;
                                        if (callbackurl.indexOf('?') > -1) {
                                            redirectUrl = callbackurl + '&token=' + res.data.data.token;
                                        } else {
                                            redirectUrl = callbackurl + '?token=' + res.data.data.token;
                                        }
                                        window.location.href = redirectUrl;
                                    } else {
                                        const { href } = this.$router.resolve({
                                            path: redirectUrl,
                                        });
                                        window.location.href = href;
                                    }
                                }, 100);
                            }
                        } else {
                            this.logintext = '登录';
                            this.$msgmodal({
                                title: '系统提示',
                                content: '登陆失败，请稍后再试!',
                                type: 'warn',
                            });
                        }
                    });
            }
        },
        async outClearToken(token) {
            var _tokenkey = this.$cookies.get('token_chinagp');
            await this.httphelper
                .post('/api/LoginApi/ClearToken', {
                    tokenKey: _tokenkey,
                })
                .then(res => {
                    this.$cookies.set('token_chinagp', token);
                });
        },
    },
};
</script>

<style scoped>
/* 每套全部引入 */
/* 每套页面对应的公共样式,每套页面都会引用 */
.wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
}

input {
    height: 40px;
    border: 1px solid #ddd;
    box-sizing: border-box;
    outline: none;
    padding-left: 12px;
}

.title {
    font-size: 110px;
    color: #fff;
    position: relative;
}

.title:before {
    content: '';
    display: inline-block;
    width: 60px;
    height: 5px;
    background: #ffffff;
    border-radius: 2px;
    position: absolute;
    top: -5px;
}

.titleSub {
    font-size: 40px;
    color: #fff;
    margin-bottom: 20px;
}

.english {
    font-size: 16px;
    color: #ffffff;
}

.english:after {
    content: '————';
    margin-left: 10px;
}

.english img {
    vertical-align: middle;
    margin-right: 10px;
}

.width100 {
    width: 100%;
}

.headBar {
    height: 60px;
}

.headBarRight a {
    margin-right: 30px;
}

.headBarRight a img {
    margin-right: 8px;
}

.content {
    min-width: 1300px;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: url('../../assets/img/loginbg.png');
}

.formContent {
    display: flex;
    flex: 1;
}

/* .formRightWrap {
    width: 700px;
} */
.formBlock {
    background: #fff;
    width: 340px;
    padding-top: 40px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 36px;
    border-radius: 30px 0 30px 0;
    box-sizing: border-box;
    position: relative;
}

.bianjiao {
    position: absolute;
    right: 0;
    top: 0;
}

.bianjiaobtn {
    position: absolute;
    right: 40px;
    top: 13px;
    color: #0b8686;
    font-size: 12px;
    width: 76px;
    height: 22px;
    box-sizing: border-box;
    padding-left: 10px;
    line-height: 22px;
    background: url('../../assets/img/login/bianjaiobtn.png');
}

.login_title {
    border-bottom: 1px solid #ddd;
    font-size: 16px;
    margin-bottom: 30px;
}

.login_title span {
    display: inline-block;
    padding: 0 14px;
    padding-bottom: 10px;
    font-weight: bold;
    color: #0b8686;
    border-bottom: 2px solid #0b8686;
}

.login_title a {
    display: inline-block;
    padding: 0 14px;
    padding-bottom: 10px;
    font-weight: bold;
}

.login_title_active {
    color: #0b8686;
    border-bottom: 2px solid #0b8686;
}

.inputBar {
    display: flex;
    margin-bottom: 20px;
}

.btnNormal {
    display: inline-block;
    height: 40px;
    text-align: center;
    line-height: 40px;
    width: 104px;
    background: #e1e1e1;
}

.btnSubmit {
    width: 100%;
    height: 40px;
    text-align: center;
    display: inline-block;
    line-height: 40px;
    color: #fff;
    background: #0b8686;
}

.footer {
    height: 50px;
    background: rgba(255, 255, 255, 0.05);
}

.beian {
    color: #fff;
}

.footer a {
    color: #fff;
    margin-left: 30px;
}

/* 登录2 */
.successTip {
    height: 240px;
    flex-direction: column;
}

.successTipText {
    font-size: 22px;
    color: #0b8686;
    line-height: 1.6em;
}

.Erro {
    border: 1px solid red;
}

.input-with-select .el-input-group__prepend {
    background-color: #fff;
}

.el-select ::v-deep .el-input {
    width: 80px;
}
</style>
